<h3 class="title-divider">
  {{ "ErgebnisoptionenGrundstueckbeschreibung" | translate }}
</h3>
<fieldset [disabled]="disabled" capAtLeastOneValidator ngModelGroup="grundstueckbeschreibung">
  <cap-form-control labelKey="FlaecheWertquote">
    <input (ngModelChange)="model && (model.flaeche = $event)" [ngModel]="model && model.flaeche" name="flaeche" type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Sonderrechte">
    <input
      (ngModelChange)="model && (model.sonderrechte = $event)"
      [ngModel]="model && model.sonderrechte"
      name="sonderrechte"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="AvBemerkung">
    <input
      (ngModelChange)="model && (model.avBemerkung = $event)"
      [ngModel]="model && model.avBemerkung"
      name="avBemerkung"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="BelasteteTeilflaechen">
    <input
      (ngModelChange)="model && (model.belasteteTeilflaechen = $event)"
      [ngModel]="model && model.belasteteTeilflaechen"
      name="belasteteTeilflaechen"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Lagebezeichnung">
    <input
      (ngModelChange)="model && (model.grundstueckAdresse = $event)"
      [ngModel]="model && model.grundstueckAdresse"
      name="grundstueckAdresse"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Bodenbedeckung">
    <input
      (ngModelChange)="model && (model.bodenbedeckung = $event)"
      [ngModel]="model && model.bodenbedeckung"
      name="bodenbedeckung"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Gebaeude">
    <input (ngModelChange)="model && (model.gebaeude = $event)" [ngModel]="model && model.gebaeude" name="gebaeude" type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="GebaeudeAdresse">
    <input
      (ngModelChange)="model && (model.gebaeudeAdresse = $event)"
      [ngModel]="model && model.gebaeudeAdresse"
      name="gebaeudeAdresse"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="GbBemerkung">
    <input (ngModelChange)="model && (model.bemerkung = $event)" [ngModel]="model && model.bemerkung" name="bemerkung" type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="AmtlicherWert">
    <input
      (ngModelChange)="model && (model.amtlicherWert = $event)"
      [ngModel]="model && model.amtlicherWert"
      name="amtlicherWert"
      type="checkbox" />
  </cap-form-control>
</fieldset>
